import Footer from "../components/Footer";
import Header from "../components/Header";
import { FaBullseye, FaEye, FaGem, FaHandshake, FaStar, FaUsers } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { PiMedal } from "react-icons/pi";

export default function Sobre() {
    const eventos = [
        {
            ano: "1992",
            titulo: "Fundação",
            descricao: "Ibiza Veículos é fundada com o sonho de oferecer os melhores carros usados da região.",
        },
        {
            ano: "2000",
            titulo: "Expansão",
            descricao: "Ampliação do showroom e início das parcerias com bancos para financiamento.",
        },
        {
            ano: "2010",
            titulo: "Modernização",
            descricao: "Investimento em tecnologia e criação do primeiro site da empresa.",
        },
        {
            ano: "2020",
            titulo: "Transformação Digital",
            descricao: "Lançamento da plataforma online completa e serviços digitais.",
        },
        {
            ano: "2025",
            titulo: "Presente",
            descricao: "Mais de 30 anos realizando sonhos e milhares de clientes satisfeitos.",
        },
    ];

    return (
        <div>
            <Header />

            <div className="relative h-[350px] w-full">
                <img
                    src="/banner.png"
                    alt="Banner do Grupo Ibiza"
                    className="object-cover w-full h-full"
                />

                <div className="absolute inset-0 bg-black/50" />

                <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
                    <h1 className="text-2xl md:text-6xl font-bold mt-20">Nossa História</h1>
                    <p className="text-lg font-semibold mt-2">Há mais de 30 anos no mercado, a Ibiza Veículos se consolidou como referência em venda de veículos usados, sempre priorizando a qualidade, confiança e satisfação dos nossos clientes.</p>
                </div>
            </div>

            <div className="flex flex-col lg:flex-row items-center justify-between gap-10 px-6 lg:px-20 py-16 bg-white">
                <div className="flex-1 max-w-xl">
                    <h2 className="text-3xl lg:text-4xl font-bold text-blue-800 mb-6">
                        Uma Jornada de Sucesso
                    </h2>
                    <p className="text-gray-700 mb-4">
                        Fundada em 1992 por uma família apaixonada por automóveis, a Ibiza Veículos
                        nasceu com o propósito de democratizar o acesso a veículos de qualidade,
                        oferecendo opções confiáveis e acessíveis para todos os perfis de clientes.
                    </p>
                    <p className="text-gray-700 mb-4">
                        Ao longo dos anos, construímos uma reputação sólida baseada na transparência,
                        qualidade dos veículos e excelência no atendimento. Cada carro que passa por
                        nossas mãos é cuidadosamente selecionado e inspecionado.
                    </p>
                    <p className="text-gray-700">
                        Hoje, somos uma das concessionárias mais respeitadas da região, com milhares de
                        clientes satisfeitos e histórias de sonhos realizados.
                    </p>
                </div>

                <div className="flex-1 w-full max-w-xl rounded-2xl overflow-hidden shadow-lg">
                    <img
                        src="/banner.png"
                        alt="Fachada da Ibiza Veículos"
                        className="rounded-2xl object-cover w-full h-auto"
                    />
                </div>
            </div>

            <div className="px-6 lg:px-20 py-16 bg-white">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
                    <div className="bg-white rounded-2xl shadow-md p-6 text-center">
                        <div className="flex justify-center mb-4 text-blue-600 text-4xl">
                            <FaBullseye />
                        </div>
                        <h3 className="text-xl font-semibold text-blue-900 mb-2">Missão</h3>
                        <p className="text-gray-600">
                            Oferecer veículos de qualidade com transparência e confiança, proporcionando
                            a melhor experiência de compra e realizando os sonhos dos nossos clientes.
                        </p>
                    </div>
                    <div className="bg-white rounded-2xl shadow-md p-6 text-center">
                        <div className="flex justify-center mb-4 text-green-600 text-4xl">
                            <FaEye />
                        </div>
                        <h3 className="text-xl font-semibold text-blue-900 mb-2">Visão</h3>
                        <p className="text-gray-600">
                            Ser reconhecida como a melhor concessionária de veículos usados da região,
                            referência em qualidade, confiança e inovação no atendimento ao cliente.
                        </p>
                    </div>
                    <div className="bg-white rounded-2xl shadow-md p-6 text-center">
                        <div className="flex justify-center mb-4 text-purple-600 text-4xl">
                            <FaGem />
                        </div>
                        <h3 className="text-xl font-semibold text-blue-900 mb-2">Valores</h3>
                        <p className="text-gray-600">
                            Transparência, qualidade, confiança, compromisso com o cliente e
                            responsabilidade social são os pilares que guiam todas as nossas ações e
                            decisões.
                        </p>
                    </div>
                </div>

                <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">
                    Nossos Diferenciais
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="bg-white rounded-2xl shadow-md p-6 text-center">
                        <div className="flex justify-center mb-4 text-blue-400 text-4xl">
                            <FaHandshake />
                        </div>
                        <h3 className="text-lg font-semibold text-blue-800 mb-2">Confiança</h3>
                        <p className="text-gray-600">
                            Construímos relacionamentos duradouros baseados na transparência e
                            honestidade.
                        </p>
                    </div>
                    <div className="bg-white rounded-2xl shadow-md p-6 text-center">
                        <div className="flex justify-center mb-4 text-yellow-500 text-4xl">
                            <FaStar />
                        </div>
                        <h3 className="text-lg font-semibold text-blue-800 mb-2">Qualidade</h3>
                        <p className="text-gray-600">
                            Selecionamos apenas veículos que passam por rigorosa inspeção de qualidade.
                        </p>
                    </div>
                    <div className="bg-white rounded-2xl shadow-md p-6 text-center">
                        <div className="flex justify-center mb-4 text-purple-400 text-4xl">
                            <FaUsers />
                        </div>
                        <h3 className="text-lg font-semibold text-blue-800 mb-2">Compromisso</h3>
                        <p className="text-gray-600">
                            Comprometidos em realizar o sonho de cada cliente com dedicação total.
                        </p>
                    </div>
                </div>
            </div>

            <div className="px-6 lg:px-20 py-16 bg-white flex justify-center">
                <div className="w-full max-w-5xl">
                    <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">Nossa Trajetória</h2>

                    <div className="relative md:pl-1 border-l-3 border-neutral-200 space-y-12">
                        {eventos.map((evento, index) => (
                            <div key={index} className="flex items-start gap-6 relative">
                                <div className="absolute -left-[38px] top-1 ml-4 md:ml-0">
                                    <div className="w-16 h-16 bg-blue-800 text-white font-bold text-sm flex items-center justify-center rounded-full shadow-md">
                                        {evento.ano}
                                    </div>
                                </div>

                                <div className="bg-white shadow-md rounded-xl p-6 w-full ml-20">
                                    <h3 className="text-xl font-semibold text-blue-800 mb-1">{evento.titulo}</h3>
                                    <p className="text-gray-700">{evento.descricao}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-10 p-10 sm:mt-16 grid grid-cols-2 grid-rows-2 md:flex md:flex-row md:flex-wrap justify-center bg-[#003c85] text-white px-2 sm:p-10 md:p-20 gap-4 sm:gap-8 md:gap-20">
                <div className="flex flex-col items-center justify-center space-y-2">
                    <h3 className="text-5xl font-bold">30+</h3>
                    <p className="text-lg">Anos de Experiência</p>
                </div>

                <div className="flex flex-col items-center justify-center space-y-2">
                    <h3 className="text-5xl font-bold">5000+</h3>
                    <p className="text-lg">Clientes Satisfeitos</p>
                </div>

                <div className="flex flex-col items-center justify-center space-y-2">
                    <h3 className="text-5xl font-bold">200+</h3>
                    <p className="text-lg">Veículos em Estoque</p>
                </div>

                <div className="flex flex-col items-center justify-center space-y-2">
                    <h3 className="text-5xl font-bold">98%</h3>
                    <p>Taxa de Aprovação</p>
                </div>
            </div>

            <div className="flex justify-center items-center flex-col mt-20">
                <h2 className="text-4xl font-bold text-blue-800">Visite Nossa Loja!</h2>
                <p className="text-neutral-600 mt-4 text-center p-4">
                    Venha conhecer nossa história de perto e descubra por que somos <br /> a escolha de milhares de clientes satisfeitos.
                </p>

                <div className="flex gap-6 mt-8 mb-10">
                    <a href="/contato" className="flex items-center gap-2 bg-blue-900 text-white font-semibold px-6 py-3 rounded-lg hover:bg-blue-800 transition-colors">
                        <IoLocationOutline />
                        Entre em Contato
                    </a>

                    <a href="/estoque" className="flex items-center gap-2 border-2 border-blue-800 text-blue-800 font-semibold px-6 py-3 rounded-lg hover:bg-blue-50 transition-colors">
                        <PiMedal />
                        Ver Estoque
                    </a>
                </div>
            </div>

            <Footer />
        </div>
    )
}